<template>
  <div>
    <el-dialog :class="{'deleted-css': false}" :title="'温馨提示'" v-loading.fullscreen.lock="loading" :visible="show" :close-on-click-modal="false" width="40%" @close="close">
      <div class="dia_wrap">
        <el-form class="form" ref="formRef" :model="formData" label-position="left" label-width="110px" size="mini">
          <div>
            <div class="h_bg p50">
              <h3>您提交的价格为:</h3> <span class="ml20" style=" background: #e8f1ff; border-radius: 18px; font-size: 30px; font-weight: bold;padding: 10px 20px; color: #047eff; ">￥{{ data.quotedAmount }}元{{unitAppend}}</span>
            </div>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="btn">
        <el-button class="sumbit" @click="saveAndSubmitBtn()">确认出价</el-button>
        <el-button @click="close">先不出价</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Upload from '@/components/Upload/UpLoad.vue'
import Dialog from '@/components/Dialog'
import payQrcode from '@/components/payQrcode'
import faceQrcode from '@/components/faceQrcodes/index.vue'
import OneUpload from '@/components/DataUpload/OneUpload.vue'
import ListUpload from '@/components/DataUpload/ListUpload.vue'
import paySure from '@/components/paySure/index.vue'
import AgreeDialog from '@/components/agreeDialog'
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: '',
    },
    delistingData: {
      type: Object,
      default: '',
    },
    unitAppend: {
      type: String,
      default: false,
    },
  },
  components: {
    Upload,
    Dialog,
    OneUpload,
    ListUpload,
    payQrcode,
    faceQrcode,
    paySure,
    AgreeDialog,
  },
  data() {
    return {
      loading: false,
      formData: {
        listingApplyId: '',
        amount: '', //
      }

    }
  },
  watch: {
    show: {
      async handler(newVal, oldVal) {
        if (newVal == true) {
          this.formData.amount = this.data.quotedAmount
          this.formData.listingApplyId = this.data.id
        }
      },
    }
  },
  methods: {
    close() {
      this.$emit('dialogCloses', false)
    },
    async saveAndSubmitBtn() {
      console.log(this.formData)
      console.log(this.delistingData)
      this.formData = {
        ...this.formData,
        ...this.delistingData,
        feeType: this.data.tranferType == 1 ? "0" : "1",
      }
      // console.log('出价')
      // console.log(this.formData)
      await this.$api.my.operate(this.formData).then((res) => {
        if (res.code === 1000) {
          this.$emit('diaSuccessEvt', true)
          this.loading = false
        } else {
          this.loading = false
        }
      }).catch((error) => {
        this.loading = false
      }).finally(() => {

      })
    },
  }
}
</script>
<style lang="scss">
.deleted-css {
  .el-dialog__body {
    padding-top: 0;
  }
}
.btn {
  text-align: center;
  margin: auto;
  display: block;
}
.form {
  /deep/.actives {
    .el-form-item__label::before {
      content: '*';
      display: inline-block;
      vertical-align: middle;
      color: #f56c6c;
      margin-right: 4px;
      font-size: 20px;
    }
  }
}
</style>
